module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("71JyS"))).then(() => parcelRequire('lzw9f'));